import React from "react";
import {
    ModalBody,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Printer from "./PrinterApplicationForm/Printer";
import { Monetics } from "./MoneticsApplicationForm/Monetics";
import CashManagement from "./CashManagementApplicationForm/CashManagement";
import { useSelector } from "react-redux";

type MenuWrapperType = {
    setIsDeviceAssociateModalOpened: Function;
    oneShop: boolean;
    isDeviceAssociateModalOpened: boolean;
    rowData: any;
    dataIsUpdated: boolean | number;
    setDataIsUpdated: Function;
};

type TabsMenuType = {
    title: string;
    content: React.ReactNode;
    subMenu?: {
        title: string;
        content: React.ReactNode;
    }[];
};

export function MenuWrapperAssociate({
    setIsDeviceAssociateModalOpened,
    oneShop,
    isDeviceAssociateModalOpened,
    rowData,
    dataIsUpdated,
    setDataIsUpdated,
}: MenuWrapperType) {
    const { t } = useTranslation();

    const [activeTab, setActiveTab] = React.useState<number>(0);
    const [activeSubTab, setActiveSubTab] = React.useState<number>(0);
    const [isSubMenuCollapsed, setIsSubMenuCollapsed] = React.useState<boolean>(
        false
    );
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );

    const tabs: TabsMenuType[] = [
        {
            title: t("Printers"),
            content: (
                <Printer
                    setIsDeviceAssociateModalOpened={
                        setIsDeviceAssociateModalOpened
                    }
                    rowData={rowData}
                    oneShop={oneShop}
                    isDeviceAssociateModalOpened={isDeviceAssociateModalOpened}
                    dataIsUpdated={dataIsUpdated}
                    setDataIsUpdated={setDataIsUpdated}
                />
            ),
        },
        {
            title: t("Monetics"),
            content: (
                <Monetics
                    rowData={rowData}
                    setIsDeviceAssociateModalOpened={
                        setIsDeviceAssociateModalOpened
                    }
                    isDeviceAssociateModalOpened={isDeviceAssociateModalOpened}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                />
            ),
        },
        {
            title: t("Coiners"),
            content: (
                <CashManagement
                    rowData={rowData}
                    setIsDeviceAssociateModalOpened={
                        setIsDeviceAssociateModalOpened
                    }
                    isDeviceAssociateModalOpened={isDeviceAssociateModalOpened}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                />
            ),
        },
        {
            title: t("Beepers"),
            content: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
        if (isSubMenuCollapsed === true) {
            setIsSubMenuCollapsed(false);
        }
    }

    function toggleSubNav(tab: number) {
        if (activeSubTab !== tab) {
            setActiveSubTab(tab);
        }
    }

    return (
        <ModalBody className="p-0 modal-associate__clz">
            <div style={{ display: "grid", gridTemplateColumns: "220px 1fr" }}>
                <Nav
                    tabs
                    className="d-flex flex-column"
                    style={{
                        backgroundColor: mainColor,
                        marginBottom: "81px",
                        fontSize: "15px",
                    }}
                >
                    {tabs.map((element, index) => {
                        return (
                            <NavItem
                                key={index}
                                className={classNames("pb-1", {
                                    "active menu-wrapper-items-nav-link-active__clz":
                                        activeTab === index,
                                })}
                            >
                                <NavLink
                                    className={classNames(
                                        "border-0 menu-wrapper-nav-link__clz",
                                        {
                                            "active menu-wrapper-items-nav-link-active__clz":
                                                activeTab === index,
                                        }
                                    )}
                                    onClick={() => {
                                        toggleNav(index);

                                        if (
                                            element.title === t("Scale") ||
                                            element.title === t("Beepers") ||
                                            element.title === t("Smartill")
                                        ) {
                                            setActiveTab(0);
                                        }
                                    }}
                                >
                                    <span className="px-2">
                                        {element.title}
                                    </span>
                                </NavLink>
                                {element.title === t("Scale") &&
                                isSubMenuCollapsed
                                    ? element.subMenu?.map(
                                          (
                                              item: {
                                                  title: string;
                                                  content: React.ReactNode;
                                              },
                                              subMenuIndex: number
                                          ): JSX.Element => (
                                              <NavLink
                                                  key={subMenuIndex}
                                                  className={classNames(
                                                      "border-0 text-nowrap pl-5 menu-wrapper-nav-link__clz",
                                                      {
                                                          "active options-nav-link-active__clz":
                                                              activeSubTab ===
                                                              subMenuIndex,
                                                      }
                                                  )}
                                                  onClick={() => {
                                                      toggleSubNav(
                                                          subMenuIndex
                                                      );
                                                  }}
                                              >
                                                  <span className="px-2">
                                                      {item.title}
                                                  </span>
                                              </NavLink>
                                          )
                                      )
                                    : null}
                            </NavItem>
                        );
                    })}
                </Nav>
                <TabContent activeTab={activeTab}>
                    {tabs.map((element, index) => {
                        return element.subMenu !== undefined &&
                            isSubMenuCollapsed ? (
                            element.subMenu?.map(
                                ({ content }, subMenuIndex) => {
                                    return (
                                        <TabPane
                                            tabId={index}
                                            className={classNames({
                                                "d-none":
                                                    subMenuIndex !==
                                                    activeSubTab,
                                            })}
                                            style={{
                                                height: "100%",
                                                width: "100%",
                                                overflow: "hidden",
                                            }}
                                            key={subMenuIndex}
                                        >
                                            {content}
                                        </TabPane>
                                    );
                                }
                            )
                        ) : (
                            <TabPane
                                tabId={index}
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    overflow: "hidden",
                                }}
                                key={index}
                            >
                                {element.content}
                            </TabPane>
                        );
                    })}
                </TabContent>
            </div>
        </ModalBody>
    );
}
